import { Typography } from 'shared/ui'
import type { IColumn } from 'shared/ui/TableNew'
import { getCurrencySymbol } from 'shared/lib/currency'
import type { RowConversion } from 'entities/Analytics/model/Table/rowConversion'

export const getColumns = (): IColumn<RowConversion>[] => [
  {
    isSortable: true,
    field: 'name',
    name: 'Name',
    fullName: 'Name',
    renderRowCell: (row) => {
      return (
        <Typography variant='body-md-regular' ellipsis ariaLabel='ConversionName'>
          {row.fields.name}
        </Typography>
      )
    },
  },
  {
    isSortable: true,
    field: 'conversion_url',
    name: 'URL',
    fullName: 'URL',
    renderRowCell: (row) => {
      return (
        <Typography variant='body-md-regular' ellipsis ariaLabel='ConversionUrl'>
          {row.fields.conversion_url}
        </Typography>
      )
    },
  },
  {
    isSortable: true,
    field: 'default_value',
    name: 'Default value',
    fullName: 'Default value',
    renderRowCell: (row) => {
      const { default_value, currency } = row.fields

      return (
        <Typography variant='body-md-regular' ariaLabel='DefaultValue'>
          {getCurrencySymbol(currency)}
          {default_value}
        </Typography>
      )
    },
  },
  {
    isSortable: true,
    field: 'conversion_rate',
    name: 'Conversion rate',
    fullName: 'Conversion rate',
    renderRowCell: (row) => {
      return (
        <Typography variant='body-md-regular' ariaLabel='ConversionRate'>
          {row.fields.conversion_rate}%
        </Typography>
      )
    },
  },
  {
    isSortable: true,
    field: 'conversion_revenue',
    name: 'Conversion revenue',
    fullName: 'Conversion revenue',
    renderRowCell: (row) => {
      return (
        <Typography variant='body-md-regular' ariaLabel='ConversionRevenue'>
          {row.fields.conversion_revenue}
        </Typography>
      )
    },
  },
]
